

import Vue from 'vue'
import VueRouter from 'vue-router'
import FastClick from 'fastclick'
import App from './App'
import router from './router'
import AjaxPlugin from 'vux/src/plugins/ajax/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import DatetimePlugin from 'vux/src/plugins/datetime/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'


import '../static/js/json3.min.js'
import global_ from './components/global'

Vue.use(ToastPlugin);
Vue.use(AjaxPlugin);
Vue.use(LoadingPlugin);
Vue.use(VueRouter);
Vue.use(AlertPlugin);
Vue.use(ConfirmPlugin);
Vue.use(DatetimePlugin)

FastClick.attach(document.body)

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
if (!global_.entryUrl && to.path !== '/login' && to.path.indexOf('?') === -1) {
global_.entryUrl = to.fullPath
}
if (to.path === '/download') {
next()
return
}
let openid = localStorage.getItem('openid') || global_.openid;
let unionid = localStorage.getItem('unionid') || global_.unionid;
if (!openid ||!unionid ||(openid === unionid)) {
if (to.query.code) {
AjaxPlugin.$http.get('/api/v1/wechat/?code=' + to.query.code + '&state=' + to.query.state).then((response) => {
localStorage.setItem('openid', response.data.openid);
if(response.data.unionid){
localStorage.setItem('unionid', response.data.unionid);
global_.unionid = response.data.unionid;
}



global_.openid = response.data.openid;

window.location.reload();
}).catch(function (error) {
alert('服务器错误，请稍后重试')
})
} else {
AjaxPlugin.$http.get('static/config.json').then(response => {
const appid = response.data.appId;



window.location.href = 'http://viwo.fineone.com.cn/get-weixin-code.html?appid=' + appid + '&scope=snsapi_userinfo&state=STATE&redirect_uri=' + response.data.host + to.fullPath;
}, response => {
console.log('数据加载失败')
})
}
} else {
const whiteList = ['/forgetpassword', '/register', '/login', '/rapidrepairs', "/sbxx", "/smallbox", "/attention", '/protocal', '/faultType',
'/rapidrepairslist', '/userhomepage', "/quicklycomplete", '/quicksetup', '/normalrepairs', '/normalrepairslist', '/photo',
'/repair', '/RegisterType', '/engineer', '/Devicelist', '/filing', '/viwocertificate', '/resume', '/apply', '/resumelist', '/preparation']// 免登录白名单
if (whiteList.indexOf(to.path) === -1) {
AjaxPlugin.$http.get('/api/v1/wechat/' + localStorage.getItem('unionid')).then(res => {
if (res.data.length === 0) {
next('/login');
} else {
localStorage.setItem('account', JSON.stringify(res.data));
next()
}
})
} else {
next();
}
}
})

router.afterEach((to, from) => {

})
new Vue({
router,
render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js